module.exports = __webpack_public_path__ + "static/img/nada.ff82620.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/buttons/nada.png
// module id = 221
// module chunks = 1